/**
 * A burst of ~10+ Supabase queries fires in parallel on mount (profiles,
 * vaults, channels, roles, invite previews, etc.), which can briefly exceed
 * the Postgres connection pool and statement-timeout a handful of them
 * (transient 500s, HAR-confirmed to cluster within the same instant). This
 * retries a PostgREST-style `{ data, error }` call a few times with backoff
 * before giving up, so a transient pool-contention failure self-heals in
 * ~1.5s instead of leaving stale/default UI state in place.
 */
export async function retryQuery<R extends { data: any; error: any }>(
  fn: () => PromiseLike<R>,
  delaysMs: number[] = [0, 400, 1200],
): Promise<R> {
  let result: R;
  for (let attempt = 0; attempt < delaysMs.length; attempt++) {
    if (delaysMs[attempt] > 0) await new Promise(r => setTimeout(r, delaysMs[attempt]));
    result = await fn();
    if (!result.error) return result;
  }
  return result!;
}
